import { render, staticRenderFns } from "./TextRow.vue?vue&type=template&id=040f1e3f&scoped=true&"
import script from "./TextRow.vue?vue&type=script&lang=js&"
export * from "./TextRow.vue?vue&type=script&lang=js&"
import style0 from "./TextRow.vue?vue&type=style&index=0&id=040f1e3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f1e3f",
  null
  
)

export default component.exports